import { useState } from 'react';
import { siteInfo } from '@/mocks/categories';

export default function FooterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubmitted(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          <div className="md:col-span-1">
            <h3 className="text-3xl md:text-4xl font-heading font-light tracking-tight mb-3">Join the Hub</h3>
            <p className="text-sm text-foreground-400 leading-relaxed mb-8 max-w-xs">
              Stay updated with the latest spreadsheet categories, new product finds, and shopping resources.
            </p>
            <form onSubmit={handleSubmit} className="max-w-xs">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="w-full bg-transparent border-b border-foreground-700 pb-2 text-sm text-background-50 placeholder-foreground-500 outline-none focus:border-primary-400 transition-colors"
                required
              />
              <div className="mt-5">
                <a
                  href={siteInfo.mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-5 py-2 bg-background-50 rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-background-100"
                >
                  <span className="text-sm font-semibold text-foreground-900">hipobuy sheet</span>
                  <span className="w-5 h-5 rounded-full bg-foreground-900 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs text-background-50"></i>
                  </span>
                </a>
              </div>
            </form>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <a
                href={siteInfo.mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap underline decoration-foreground-700 underline-offset-4"
              >
                hipobuy sheet
              </a>
              <a
                href={siteInfo.mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap underline decoration-foreground-700 underline-offset-4"
              >
                buy it now
              </a>
              <a
                href="#categories"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap underline decoration-foreground-700 underline-offset-4"
              >
                All Categories
              </a>
              <a
                href="/hipobuy-spreadsheet-guide"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap underline decoration-foreground-700 underline-offset-4"
              >
                Editorial Guides
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">About</h4>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              Hipobuy Spreadsheet Hub is an independent educational resource providing organized product discovery tools and shopping guides for global shoppers.
            </p>
            <a
              href={siteInfo.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Main Website &rarr;
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="#" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-700 underline-offset-4">
              X / Twitter
            </a>
            <a href="#" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-700 underline-offset-4">
              Pinterest
            </a>
            <a href="#" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-700 underline-offset-4">
              Reddit
            </a>
          </div>
          <p className="text-xs text-foreground-600">
            &copy; 2026 Hipobuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-700 underline-offset-4 whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-700 underline-offset-4 whitespace-nowrap">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}